import './slider.scss';
export function generateSliders(element) {
  var sliderNeeded = document.querySelectorAll(element + '[data-slider]');
  if (sliderNeeded) {
    sliderNeeded.forEach(function ($this) {
      if ($this.classList.contains('slider-initialized')) {
        return;
      }
      var sliderConfiguration = $this.getAttribute('data-slider');
      sliderConfiguration = JSON.parse(sliderConfiguration);
      import('tiny-slider/src/tiny-slider').then(({
        tns
      }) => {
        // Import Tiny slider css
        import('./tiny-slider.scss');

        // Not override-able settings for the slider that need to be defined
        sliderConfiguration['container'] = $this;
        sliderConfiguration['mouseDrag'] = true;
        sliderConfiguration['nav'] = false;
        sliderConfiguration['autoplayButton'] = false;
        sliderConfiguration['autoplayButtonOutput'] = false;
        sliderConfiguration['controlsText'] = [theme_object.filters.slider_icon_previous, theme_object.filters.slider_icon_next];
        if (sliderConfiguration['variables'] != undefined) {
          if (sliderConfiguration['variables']['controlsPosition'] != undefined) {
            var controlsPosition = sliderConfiguration['variables']['controlsPosition'];
          }
        }

        // Initialize the Tiny Slider
        var slider = tns(sliderConfiguration);
        $this.classList.add('slider-initialized');
        if (controlsPosition != undefined) {
          var sliderOuter = $this.parentElement.parentElement.parentElement;
          sliderOuter.querySelector('.tns-controls').classList.add(controlsPosition);
        }
        const tnsOuter = $this.closest('.tns-outer');
        if (tnsOuter) {
          const controls = tnsOuter.querySelector('.tns-controls');
          const controlPrevButton = tnsOuter.querySelector('.tns-controls button[data-controls="prev"]');
          const controlNextButton = tnsOuter.querySelector('.tns-controls button[data-controls="next"]');
          if (controls) {
            controls.removeAttribute('aria-label');
          }
          if (controlPrevButton) {
            controlPrevButton.setAttribute('aria-label', theme_object.messages.tns_previous_slide);
          }
          if (controlNextButton) {
            controlNextButton.setAttribute('aria-label', theme_object.messages.tns_next_slide);
          }
        }

        // Accessibility: Manage tabindex on hidden/visible slides
        const update_slide_tabindex = () => {
          const slides = $this.querySelectorAll('.tns-item');
          slides.forEach(slide => {
            const buttons = slide.querySelectorAll('button, a, input, select, textarea');
            if (slide.getAttribute('aria-hidden') === 'true') {
              buttons.forEach(btn => btn.setAttribute('tabindex', '-1'));
            } else {
              buttons.forEach(btn => btn.removeAttribute('tabindex'));
            }
          });
        };
        update_slide_tabindex();
        slider.events.on('indexChanged', update_slide_tabindex);
      }).catch(error => {
        console.error("Error loading Tiny Slider:", error);
      });
    });
  }
}

// Make generateSliders function global available so that it can be used in child themes
if (typeof window !== 'undefined') {
  window.lef_slider = window.lef_slider || {};
  window.lef_slider.generateSliders = generateSliders;
}